import { useQuery } from '@tanstack/react-query';
import { api } from './api';

export interface AuditEvent {
  id: number;
  userId: string | null;
  action: string;
  targetKind: string | null;
  targetId: string | null;
  ip: string | null;
  userAgent: string | null;
  details: Record<string, unknown> | null;
  createdAt: string;
}

export function useAuditLog(params: { action?: string; prefix?: string; targetKind?: string; targetId?: string; userId?: string; limit?: number } = {}) {
  return useQuery({
    queryKey: ['audit-log', params],
    queryFn: async () => {
      const r = await api.get<{ events: AuditEvent[] }>('/api/audit-log', { params });
      return r.data.events;
    },
  });
}
